<template>
  <v-container fluid tag="section">
    <v-row no-gutters>
      <v-col class="d-flex justify-center" offset-md="5" md="2" cols="12">
        <v-select v-model="selectedEsercizio" @change="loadData()" :items="listEsercizi" item-text="season"
          item-value="annoCurEse" :menu-props="{ maxHeight: '400' }" :label="$t('accounting_exercise')" required
          color="primary" :hint="$t('pick_accounting_exercise')" persistent-hint></v-select>

        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon color="primary" large v-on="on" style="cursor: pointer" class="mr-2"
              @click.native="getPdf()">mdi-file-pdf-box</v-icon>
          </template>
          <span>{{ $t("download_pdf") }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row>
      <v-layout justify-center style="flex-wrap: wrap">
        <v-col v-if="rendiconto" md="6" cols="12">
          <v-row>
            <v-col cols="12">
              <v-simple-table>
                <thead>
                  <tr>
                    <th>
                      <h2>AVANZO DI GESTIONE</h2>
                    </th>
                    <th class="text-right">
                      <h2>{{ Number(rendiconto.avanzoGestione).toFixed(2) }}</h2>
                    </th>
                  </tr>
                  <tr>
                    <th>
                      <h2>TOTALE A PAREGGIO</h2>
                    </th>
                    <th class="text-right">
                      <h2>{{ Number(rendiconto.totalePareggio).toFixed(2) }}</h2>
                    </th>
                  </tr>
                </thead>
              </v-simple-table>
            </v-col>
            <v-col md="6" cols="12">
              <v-simple-table>
                <thead>
                  <tr>
                    <th>
                      <h2>Entrate</h2>
                    </th>
                    <th class="text-right">
                      <h2>{{ Number(rendiconto.totaleEntrate).toFixed(2) }}</h2>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="entrata in rendiconto.entrate" v-bind:key="entrata.key">
                    <td>{{ entrata.dex }}</td>
                    <td class="text-right">
                      {{
                        Number(entrata.value) !== 0
                        ? Number(entrata.value).toFixed(2)
                        : ""
                      }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col md="6" cols="12">
              <v-simple-table>
                <thead>
                  <tr>
                    <th>
                      <h2>Uscite</h2>
                    </th>
                    <th class="text-right">
                      <h2>{{ Number(rendiconto.totaleUscite).toFixed(2) }}</h2>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="uscita in rendiconto.uscite" v-bind:key="uscita.key">
                    <td>{{ uscita.dex }}</td>
                    <td class="text-right">
                      {{
                        Number(uscita.value) !== 0
                        ? Number(uscita.value).toFixed(2)
                        : ""
                      }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-col>
      </v-layout>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "rendiconto-cge",
  components: {},
  props: {},
  data() {
    return {
      rendiconto: null,
      listEsercizi: [],
      selectedEsercizio: 0,
    };
  },

  methods: {
    getPdf(item) {
      let url = "/auth/contab/pdf/rendiconto/" + this.selectedEsercizio;
      this.$documentViewer.documentViewerRsp.docUrl = url;
      //window.open(this.authorizeLink(url));
    },
    loadData() {
      let _ = this;
      let now = new Date();

      // Recupera esercizi
      _.listEsercizi = [];
      this.chiamataAxios("GET", "auth/contab/listEsercizi").then((response) => {
        _.listEsercizi = response.data.listEsercizi;
        if (!_.selectedEsercizio || _.selectedEsercizio === 0)
          _.selectedEsercizio = response.data.curEsercizio.annoCurEse;
      });

      _.rendiconto = null;
      _.isFetching = true;
      this.chiamataAxios(
        "GET",
        "auth/contab/rendiconto/" + _.selectedEsercizio
      ).then((response) => {
        // Customize response
        _.rendiconto = response.data;
        _.isFetching = false;
      });
    },
  },
  created() {
    this.loadData();
  },
};
</script>